import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import useToken from 'hooks/useToken';
import { Col, Row } from 'react-bootstrap';


import ListaFacturasRecibidas from './lista-facturas/ListaFacturasRecibidas';
import { useToast } from 'context/providers/ToastProvider';


const Recibidas = () => {

    const navigate = useNavigate();
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast } = useToast();

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }


    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();

    }, []);

    return (
        <>
            <Row>
                <Col className="col-12">
                    <ListaFacturasRecibidas />
                </Col>
            </Row>


        </>
    );
};

export default Recibidas;
